import useUserDataStore from "./useUserDataStore";

const TOTAL_VATS = 2;

export default function usePermissions() {
  const userData = useUserDataStore(state => state.userData);
  const permissions = userData?.permissions;

  const canAccess = ({ appSlug }) =>
    permissions && permissions && !!permissions.find(item => item === `${appSlug}.can-access`);

  const canDisplayVats = permissions?.find(item => item === "neotreso.can-display-vats");

  const canDisplayCategories = permissions?.find(
    item => item === "neotreso.can-display-categories",
  );

  const canDisplayTransactions = permissions?.find(
    item => item === "neotreso.can-display-transactions",
  );

  const canDisplayBanks = permissions?.find(item => item === "neotreso.can-display-banks");
  const canUpdateBanks = permissions?.find(item => item === "banks-api.can-update-banks");
  const canUpdateCompaniesBanks = permissions?.find(
    item => item === "banks-api.can-update-companies-banks",
  );

  const canCreateCompaniesBanks = permissions?.find(
    item => item === "banks-api.can-create-companies-banks",
  );

  const canCreateVats = () =>
    permissions && !!permissions.find(item => item === "central-api.can-create-vats");

  const canUpdateVats = () => {
    const permissionsList =
      permissions &&
      permissions.filter(
        item =>
          item === "central-api.can-update-vats" || item === "central-api.can-view-counter-parts",
      );
    return permissionsList?.length === TOTAL_VATS;
  };

  const canUpdateCycles = () =>
    permissions && !!permissions.find(item => item === "central-api.can-update-cycles");

  const canUpdateCompany =
    permissions && !!permissions.find(item => item === "dashboard.can-display-companies");

  return {
    canAccess,
    canDisplayVats,
    canDisplayCategories,
    canDisplayTransactions,
    canDisplayBanks,
    canUpdateBanks,
    canUpdateCompaniesBanks,
    canCreateCompaniesBanks,
    canCreateVats,
    canUpdateVats,
    canUpdateCycles,
    canUpdateCompany,
  };
}
